module.exports = __webpack_public_path__ + "img/btn3-415x300.d2020e3f.jpg";